"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _image = require("@site/pattern-library-core/image");
var _motionMove = _interopRequireDefault(require("../../../experiments/animation/motion-move"));
/**
 * Local Imports
 */

const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-s1jjkjgp"
});
const Inner = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "Inner",
  class: "pl-i1hiyfts",
  vars: {
    "i1hiyfts-0": [({
      reverse
    }) => reverse ? 'column-reverse' : 'column']
  }
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h95ku1b"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "ImageContainer",
  class: "pl-i8ifoqj"
});

/**
 * FeaturesStorySection Component.
 * @module FeaturesStorySection
 *
 * @param {Object} props React props
 * @param {String} props._name Identifier for tracking
 * @param {Boolean} props.invert Invert
 * @param {String} props.partial Theme partial
 * @param {Boolean} props.reverse Reverse Layout
 * @param {Object} props.portait Mobile image object
 * @param {Object} props.tablet Tablet image object
 * @param {Object} props.landscape Desktop image object
 * @param {Object} props.headlineLockup HeadlineLockup component props
 * @param {String} props.verticalMargin Vertical margin
 * @returns {React.ReactElement} FeaturesStorySection Component
 * @public
 */

function FeaturesStorySection({
  _name,
  invert = false,
  partial,
  reverse = false,
  portrait,
  tablet,
  landscape,
  verticalMargin = 'none',
  ...rest
}) {
  const backgroundImages = {
    portrait: portrait?.url,
    tablet: tablet?.url,
    landscape: landscape?.url
  };
  const {
    headlineLockup
  } = rest;
  const renderHeadlineReact = /*#__PURE__*/_react.default.isValidElement(headlineLockup);
  return /*#__PURE__*/_react.default.createElement(SectionContainer, {
    _name: _name,
    dataCy: "features-story-section",
    padding: "none",
    partial: partial || (invert ? 'dark1' : ''),
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(Inner, {
    mode: "fluid",
    intensity: "400",
    variant: "moveUpFixed",
    staggerChildren: true,
    triggerOnce: true,
    reverse: reverse
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, renderHeadlineReact ? headlineLockup : /*#__PURE__*/_react.default.createElement(_index.default, rest)), /*#__PURE__*/_react.default.createElement(ImageContainer, (0, _extends2.default)({}, backgroundImages, {
    "data-cy": "image-container"
  }))));
}
var _default = exports.default = FeaturesStorySection;
FeaturesStorySection.propTypes = {
  _name: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  reverse: _propTypes.default.bool,
  portrait: _propTypes.default.object,
  tablet: _propTypes.default.object,
  landscape: _propTypes.default.object,
  headlineLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  verticalMargin: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};